import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_CODE_ITEMS_LIST } from '../queries/GetCodeItemsList';
import { GENERAL_TAB } from '../../Utilities/constants';

const fetchCodeOptions = async ({ queryKey }) => {
  const [, { currentLine, token, codeNumber = null }] = queryKey;

  try {
    const url = codeNumber
      ? `/selectionsByCodeNum?&codeNumber=${encodeURIComponent(codeNumber)}&prodFamilyId=${encodeURIComponent(currentLine)}&viewOption=${encodeURIComponent(GENERAL_TAB)}`
      : `/selectionsByCodeNum?&prodFamilyId=${encodeURIComponent(currentLine)}&viewOption=${encodeURIComponent(GENERAL_TAB)}`;

    const response = await axios.get(url, {
      headers: { Authorization: token },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching code selections:', error);
    throw error;
  }
};

export const useGetSelectionsByCodeNum = (params) => {
  return useQuery({
    queryKey: [GET_CODE_ITEMS_LIST, params],
    queryFn: fetchCodeOptions,
    enabled: !!params.token && !!params.currentLine,
    retry: false,
  });
};
